<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="banner-title">
                    <div class="title">
                        <h1>無料オンライン句読点チェックツール
                        </h1>
                    </div>
                    <p>AIを搭載した自動英文校正ツールTrinka（トリンカ）の無料句読点チェックツールが、句読点の間違いをリアルタイムで修正。
                        TrinkaのAIで句読点のミスを検出し修正していけば、自信をもって英作文ができます。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="multiTabSection">
                    <ul class="nav nav-tabs" role="tablist">
                    </ul>
                    <app-english-grammar-checker></app-english-grammar-checker>
                </div>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<div class="trinka-banner section-pd-sm d-lg-block d-none" id="real-time">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">TrinkaをChromeにインストールしていつでも正確な英文作成を
                    </h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a  id="GCChromeButton3" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" class="white-btn" target="_blank"><img src="../../../assets/images/NewChromeIcon.svg" alt="chrome - 文法 チェック">Chromeにインストール</a>
                    <a  id="GCFirFoxButton3" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" class="white-btn" target="_blank"><img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox - 文法 チェック"> Firefox にインストール</a>
                    <a  id="GCEdgeButton3" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" class="white-btn" target="_blank"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge - 文法 チェック"> Edge にインストール</a>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="signupmobile trinka-banner section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">無料アカウントで<br>もっとチェック！</h3>
                    <p class="text-white">Trinkaへのご登録で、毎月5千単語まで英文チェックが無料。文法、スペル、文体の精度向上にご活用ください。</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">今すぐ登録する</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="the_best_grammer_sections section-pd">
    <div class="trinka_container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0">
                    <h2>高性能な無料オンライン読点チェックツール</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p class="w-100">Trinka読点チェックツールは、句読点が適切に使用されているかのチェックに加え、文法、スタイル、トーンの複雑なミスも修正します。</p>
                    <p class="w-100">Trinkaの人工知能（AI）は、あらゆる分野の優れた論文で学習を重ね、最適な提案を行います。Trinkaで、精度の高い英文ライティングが可能になります。</p>
                    <div class="most_suited_point">
                        <ul>
                            <li>句読点チェックの時間を節約</li>
                            <li>ご利用は無料</li>
                            <li>上質な英文を手軽に</li>
                            <li>高度なデータセキュリティ</li>
                        </ul>
                    </div>
                    <p>Trinkaのオンライン句読点チェックツールは、カンマ、ハイフン、セミコロン、その他の句読点の誤りを検出。説明付きの修正提案を提供します。</p>
                    <p>アカウント登録いただければ、Trinkaのより多くの機能を無料でお使いいただけます。</p>
                    <div class="btn-group">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="filled-btn">さっそく始める</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">Trinkaの句読点チェックツールは誰に向いている？</h3>
                    <p class="text-white">Trinkaは、英語のライティングスキルを向上させたい方に最適です。Trinkaの無料句読点チェックツールは、研究者、編集者、コピーライター、マーケター、コンテンツライター、プロダクトチーム、ブロガー、文筆家の方などに信頼されています。</p>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="the_best_grammer_sections section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinkaの読点チェックツール主な機能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>高精度の句読点チェック</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>文脈に応じた正しい句読点を提案。英文ライティングの精度を向上させます。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>In this economic recession, the Japanese economy managed to bounce back from the recession <span class="wrong_text">quickly,</span>&nbsp;<span class="right_text"> quickly</span> and achieved relatively good results.</p>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>あらゆるテーマに対応</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaは、文章のテーマや分野に基づき最適な句読点を提案します。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Syntax</h4> -->
                            <p>Therefore, it is shaped like a column if the agents have the most <span class="wrong_text">risk prone</span>&nbsp;<span class="right_text"> risk-prone</span> attitude.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>適切な単語の提案 </h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaは、句読点チェックに加え、文法や単語の選択の誤りを修正し、英語の文章を正しく明確にします。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Advance Spelling</h4> -->
                            <p>One of the reasons is <span class="wrong_text">because</span> <span
                                class="right_text"> that</span> the fabrication cost <span
                                class="wrong_text">for</span> <span class="right_text"> of</span> steel
                            members depends upon the material.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>高度なスペルチェック </h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaは、句読点の誤りを修正するだけでなく、文脈やトピックに沿った単語を提案、さらに高度なスペルチェックも行います。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p>The <span class="wrong_text">Bonferoni</span> <span
                                class="right_text"> Bonferroni</span> test was used to check for
                            statistical significance.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="use_trinka_other_app section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white">プラグイン・アドインで、
                        いつでもどこでも
                        良質なライティングを</h3>
                </div>
                <div class="use_trinka_content">
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="無料の文法チェッカーツール">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/wordAdd-in1.svg" alt="word - 文法 チェック">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="chrome - 文法 チェック">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox - 文法 チェック">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge - 文法 チェック">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/safari_logo.png" alt="safari - 文法 チェック">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>句読点の正しい使い方を学べる、Trinkaの句読点チェックツール</h3>
                    <p>句読点の修正を行うということは、句読点について学ぶことです。Trinkaの句読点チェックツールは、ミスをハイライトするだけでなく、修正の仕方やそれについての解説も示すため、英文ライティングのスキル向上に役立ちます。また、句読点チェックと同時に、文法その他のミスもチェックし、文章全体の質を示すスコアも提示します。</p>
                    <p>Trinkaの句読点チェックツールをお使いいただくことで、学生の皆様も効果的な英文ライティングを身につけることができます。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image features-img">
                    <img src="../../../assets/images/LearnGrammarwithTrinka.png" alt="最高の文法チェッカーツール">
                </div>
            </div>
        </div>
    </div>
</section>


<div class="testimonial-section text-center section-pd">
    <app-testimonial></app-testimonial>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">さっそく使ってみませんか？</h3>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="white-btn" id="grammerSignUpButton">
                            <!-- <i class="fa fa-sign-in"></i> -->
                            <span>無料登録する</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div>    

<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center">
                    <h2>Trinka句読点チェックツールについてよくあるご質問</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCOneContent" aria-expanded="true"
                                        aria-controls="QuestionGCOneContent">
                                        Trinkaの句読点チェックツールはどのように機能するのですか？</a>
                                </div>
    
                                <div id="QuestionGCOneContent" class="collapse"
                                    aria-labelledby="QuestionGCOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaの句読点チェックツールは、最新の機械学習（ML）と自然言語（NLP）技術を元に開発されており、句読点の誤りを識別し、改善案を提示します。TrinkaのAIは文構造に照らして正しい句読点が使われているかをチェックします。</p>
                                    </div>
                                </div>
                            </div>        
                            
                            <div class="card">
                                <div class="card-header" id="QuestionGCTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwoContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwoContent">Trinkaの文法・句読点チェックツールは無料ですか？</a>
                                </div>
    
                                <div id="QuestionGCTwoContent" class="collapse"
                                    aria-labelledby="QuestionGCTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい、Trinkaのベーシックプランは毎月5千単語まで完全に無料でお使いいただけます。<a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="text-link">こちら</a>からメールアドレスをご登録いただき、ツールをお使いください。</p>
                                    </div>
                                </div>
                            </div>

                            
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThreeContent" aria-expanded="true"
                                        aria-controls="QuestionGCThreeContent">Trinkaはどのような句読点エラーをチェックできますか？</a>
                                </div>
    
                                <div id="QuestionGCThreeContent" class="collapse"
                                    aria-labelledby="QuestionGCThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaでは以下の句読点の誤りをチェックできます</p>
                                        <ul>
                                            <li>カンマ（コンマ） (,)</li>
                                            <li>ピリオド (.)</li>
                                            <li> ハイフン (-)</li>
                                            <li>セミコロン (;)</li>
                                            <li>コロン (:)</li>
                                            <li>クエスチョンマーク (?)</li>
                                            <li>エムダッシュ (—)</li>
                                            <li>エンダッシュ (-)</li>
                                            <li>アポストロフィ (')</li>
                                            <li>省略記号（...）</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionGCFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFourContent" aria-expanded="true"
                                        aria-controls="QuestionGCFourContent">ウェブサイト上の句読点をチェックできますか？</a>
                                </div>
    
                                <div id="QuestionGCFourContent" class="collapse"
                                    aria-labelledby="QuestionGCFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Chrome、Firefox、Edge用のブラウザプラグインを<a  [routerLink]="['/browser-plugin']" class="text-link">インストール</a>するだけで、Trinkaの英文校正機能をお使いいただけます。</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>